<template>
  <div id="app">
    <!-- <Logining v-if="isLogining"/> -->
    <router-view v-if="isLicenced && isInit & !isLoginFail" />
    <LicenceImport v-else-if="!isLicenced" />
    <Init v-else-if="!isInit"/>
    <LoginFail v-else-if="isLoginFail"/>
  </div>
</template>

<script>
// import NavBar from '@/components/NavBar'
import store from "@/vuex/store";
import { frontConfig , checkLicence } from "./api/config"
import Init from "./views/initialization"
import LicenceImport from "./views/licence"
import LoginFail from "./views/accessKey/LoginFail";
import Logining from "./views/accessKey/Logining";
import { userLoginByAccessKeyToken } from "@/api/system/login";
import { roleMenu } from "@/api/system/menu";
import { groupDeviceTree, getAllDev } from "@/api/device/Information";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  components:{Init,LicenceImport,LoginFail,Logining},
  data() {
    return {
      AccessKeyToken: null,
      path: "",
      isRouterAlive: true,
      isInit: true,
      isLogining: true,
      isLoginFail: false,
      isLicenced: true,
      beforeUnloadTime: "",
      gapTime: ""
    };
  },
  props: {
    // reload: Function
  },
  mounted() {
    console.log("App.vue", "mounted");
    // 获取系统语言
    console.log("APP:", store.state.lang);
    this.$i18n.locale = store.state.lang;

    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e));
    window.addEventListener("unload", e => this.unloadHandler(e));
    //检查系统是否导入授权

    checkLicence().then(res=>{
      this.isLicenced = res.data
      if(res.data){
        //检查系统是否初始化
        frontConfig().then(res=>{
          this.isInit = res.initialized
        })
      }
        
      console.debug("App.vue", "mounted", "AccessKeyToken=" + this.AccessKeyToken);
      console.debug("App.vue", "mounted", "store.state.token=" + store.state.token);
      
      //todo：这里的判断逻辑需要优化
      if ($isNotNull(this.AccessKeyToken) && $isEmpty(store.state.token)) {
        console.debug("App.vue", "需执行accesskey登录操作");
        this.submit();
      } else {
        console.debug("App.vue", "不执行accesskey登录操作");
        this.$reslove();
        this.isLogining = false;
      }
    })
    .catch(res => {
      console.log("App.vue", "mounted", "checkLicence", "catch", res);
      if ($isNotNull(this.AccessKeyToken)) {
        this.isLoginFail = true;
      }

      this.$reslove();
      this.isLogining = false;
    });
  },
  destroyed() {
    window.removeEventListener("beforeunload", e =>
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", e => this.unloadHandler(e));
  },
  created() {
    console.log("App.vue", "created");
    console.debug("App.vue", "created", "url1=", JSON.stringify(window.location.search));
    console.debug("App.vue", "created", "url2=", JSON.stringify(new URLSearchParams(window.location.search)));
    console.debug("App.vue", "created", "url3=", JSON.stringify(location.href));
    const params = new URLSearchParams(window.location.search);
    this.AccessKeyToken = params.get('AccessKeyToken');
    console.debug("App.vue", "created", "AccessKeyToken=" + this.AccessKeyToken);

    window.application = this;
    this.path = this.$route.path;

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      console.debug("App.vue", "页面加载时读取", "getItem store", sessionStorage.getItem("store"));
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      console.debug("App.vue", "页面刷新前写入", "setItem store", JSON.stringify(store.state));
      sessionStorage.setItem("store", JSON.stringify(store.state));
    });

    // 如果是通过AccessKey的方式登录，则不要自动跳转了
    if ($isNotNull(this.AccessKeyToken)) {
      this.isLogining = true;
      return;
    }
      
    //判断是否登录
    if (store.state.token == null) {
      if (
        this.path.indexOf("register") == -1 &&
        this.path.indexOf("saleService") == -1 &&
        this.path.indexOf("mobile") == -1
      ) {
        this.$router.push({
          path: `/`
        });
      }
    }
  },
  methods: {
    submit() {
      this.loginLoading = true;
      const form = new FormData();
      form.append("accessKeyToken", this.AccessKeyToken);

      userLoginByAccessKeyToken(form)
      .then(res => {
        if(res.code == 210){
          this.$confirm(this.$t('index.licenceWillExpire'), this.$t('common.tips'), {
            okLabel: this.$t('button.confirm'),
            cancelLabel: this.$t("button.cancel"),
            type: "warning"});
        }
        if(res.code == 513){
          this.$confirm(this.$t('index.licenceHasExpired'), this.$t('common.tips'), {
            okLabel: this.$t('button.confirm'),
            cancelLabel: this.$t("button.cancel"),
            type: "warning"});
        }
        if (res.code == 200 ||res.code == 210 ||res.code == 513) {
          store.commit("set_token", res.data.token);
          store.commit("set_user", res.data.user);
          store.commit("set_dictionary", res.data.dictionaryList);
          this.$toast.success(this.$t("common.loginSucess"));

          roleMenu({}).then(res => {
            if (res.code == 200) {
              store.commit("set_menuArray", res.data);
            } else {
              this.$toast.warning(
                this.$t("tips.tip_msg_getFail"),
                res.message
              );
            }
            sessionStorage.setItem(
              "store",
              JSON.stringify(store.state)
            );
          });
        } else {
          this.$toast.error(res.message);
          this.loginLoading = false;
          this.isLoginFail = true;
        }

        this.$reslove();
        this.isLogining = false;
      })
      .catch(res => {
        this.$toast.error(res);
        this.loginLoading = false;
        this.isLoginFail = true;
        this.$reslove();
        this.isLogining = false;
      });
    },
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler(e) {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime;
      //判断是窗口关闭还是刷新
      if (this.gapTime <= 5) {
        navigator.sendBeacon(
          this.$axios.defaults.baseURL + "/login/loginOut",
          ""
        );
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    }
  }
};
</script>

<style>
#app {
  background: #eff2f7;
  min-height: 100vh;
}
/*.el-collapse-item__header {*/
/*  background-color: #00b7fa !important;*/
/*}*/
/*.el-collapse-item .el-collapse-item__content {*/
/*  background-color: #04101d !important;*/
/*}*/

.el-table {
  -ms-flex: none !important;
  flex: none !important;
  height: max-content;
}
</style>



// WEBPACK FOOTER //
// src/App.vue